const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    ...options,
  });

  if (!res.ok) {
    let message = `Request failed: ${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch {
      // response had no JSON body; keep the default message
    }
    throw new Error(message);
  }

  if (res.status === 204) return undefined;
  return res.json();
}

export const signup = (email, password) =>
  request("/auth/signup", { method: "POST", body: JSON.stringify({ email, password }) });

export const login = (email, password) =>
  request("/auth/login", { method: "POST", body: JSON.stringify({ email, password }) });

export const logout = () => request("/auth/logout", { method: "POST" });

export const me = () => request("/auth/me");
